import jwt_decode from "jwt-decode";
import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { editOtherService, SubmitOtherService } from "../../../store/apiCalls/profilesetup";

const OtherServiceRequest = ({updateServices = () => {}, setModalStat = () => {}, modalStat = {}}) => {
    const { id } = jwt_decode(localStorage.vendorToken || "");
    const [value, setValue] = useState(modalStat.value);
    useEffect(() => {
        setValue(modalStat.value)
    }, [modalStat.value]);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
        const body = {
            "vendorId": id,
            "serviceOfferedId": modalStat.serviceOfferedId,
            "text": value
        }
        const headers = { Authorization: `Bearer ${localStorage.vendorToken}` };
        let submitResp = {};
        const isUpdate = modalStat.service && modalStat.service.requestForOtherServiceId;
        if(isUpdate) {
            const updateData = {
                "requestForOtherServiceId": modalStat.service.requestForOtherServiceId,
                "text": body.text
            }
            submitResp = await editOtherService({body: updateData, headers})
        } else {
            submitResp = await SubmitOtherService({ body, headers})
        }
        if(submitResp?.data?.success) {
            updateServices(isUpdate ? modalStat.service.requestForOtherServiceId : submitResp?.data?.data?._id, modalStat?.uuid, value)
        }
        setModalStat({showForm: false, showMsg: true});
    }

    const handleClose = () => {
        setModalStat({showForm: false, showMsg: false});
    }

    return(
        <>
            <Modal show={modalStat.showForm} className="modal" id="requestModal" tabIndex={-1} centered>
                <form onSubmit={(e) => handleFormSubmit(e)}>
                    <div class="profileModal">
                        <div>
                            <div className="modal-content">
                                <div className="modal-header pb-3">
                                    <h5 className="modal-title">Please provide details</h5>
                                    <button
                                    type="button"
                                    className="btn-close"
                                    onClick={handleClose}
                                    />
                                </div>

                                <div className="modal-body pt-0 pb-0">
                                    <div className="px-2 feedbackContent">
                                        <div>
                                            <div>
                                                <textarea 
                                                    value={value} 
                                                    onChange={(e) => setValue(e.target.value)} 
                                                    className="fieldForm" 
                                                    name="service" 
                                                    maxLength={50}
                                                    placeholder="Explain briefly the service that you would like to register for..." 
                                                    required >
                                                </textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button
                                        className="button button-primary w-50"
                                        type="submit"
                                        disabled={!value}
                                        onClick={(e) => handleFormSubmit(e)}
                                    >
                                        Submit
                                    </button>
                                </div>
                                <div class="profileModal-note otherservice-modal">
                                    <h2>Please Note:</h2>
                                    <ol>
                                        <li>The service should be relevant to publishing industry </li>
                                        <li>Your profile will be published after we approve the service</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </Modal>
            <Modal show={modalStat.showMsg} className="modal" id="otherModal" tabIndex={-1} centered size="sm">
                <div className="modal-header">
                    <h2 className="modal-title">Thank you</h2>
                    <br />
                    <p className="received-details">We have received your details</p>
                    <button
                    type="button"
                    className="btn-close"
                    onClick={handleClose}
                    />
                </div>

                <div className="modal-body">
                    <div className="px-1">
                        <div className="other-success">
                            <ul>
                                <li>We will respond within three working day </li>
                                <li>You will receive email acknowledgement on service request approval</li>
                                <li>You can continue with your profile setup after confirmation</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button
                        className="button button-primary w-50"
                        type="submit"
                        onClick={handleClose}
                    >
                        Continue
                    </button>
                </div>
            </Modal>
        </>

    )
}


export default OtherServiceRequest;